<form class="m-form" novalidate [formGroup]="form" autocomplete="off">
    <label *ngIf="label">{{'geral.unidade' | translate}}</label>
    <ng-select [ngClass]="class" bindValue="id" bindLabel="nome" [items]="unidades$ | async" name="entidade_id" [placeholder]="'Digite o nome do Livro' | translate"
        [notFoundText]="'modulos.materiais-didaticos.nenhuma-unidade' | translate" formControlName="entidade_id" (change)="onSelect($event)" [clearable]="clearable"></ng-select>
</form>
